import { color } from "emoreg/const";
import { Flex, Position } from "emoreg/layouts";
import { rem } from "polished";
import styled from "styled-components";

const Container = styled(Flex)({
  position: "absolute",
  inset: 0,
  "&::-webkit-scrollbar": {
    width: 0,
    height: 0,
  },
});

const Button = styled.button<{ checked?: boolean }>(({ checked }) => ({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: rem(32),
  fontSize: 16,
  borderRadius: 8,
  cursor: "pointer",
  transition: "background-color 125ms ease-in-out, color 125ms ease-in-out",

  // FIXME: remove once unknown global style is fixed
  margin: 0,

  color: checked ? color.white : color.grey.darker,
  backgroundColor: checked ? color.blue.base : "transparent",
  border: "none",

  "&:hover": {
    color: checked ? color.white : color.grey.darker,
    backgroundColor: checked ? color.blue.light : color.blue.lighter,
  },
}));

const ScrollIndicator = styled(Position)<{ reversed?: boolean }>(({ reversed }) => ({
  background: `linear-gradient(to ${reversed ? "top" : "bottom"}, transparent, white)`,
}));

export const TimePickerStyle = { Container, Button, ScrollIndicator };
